<template>
  <v-card>
    <v-card-title center class="primary py-2" justify-center color="primary">
      <h3 class="text-xs-center">Mi asesor</h3>
    </v-card-title>
    <v-card-text v-if="consultantReady && orderedConsultants[currentConsultantNumber]">
      <v-layout row wrap justify-center fill-height align-start>
        <user-avatar
          icon-align="start"
          :key="currentConsultantNumber"
          :size="avatarSize"
          :user="orderedConsultants[currentConsultantNumber]"
        >
          <!--          <p class="subheading">-->
          <!--            <v-icon small>mdi-cellphone-android</v-icon>-->
          <!--            {{ orderedConsultants[currentConsultantNumber].consultant_profile.mobile }}-->
          <!--          </p>-->
          <p class="subheading">
            <v-icon small>mdi-phone</v-icon>
            {{ orderedConsultants[currentConsultantNumber].consultant_profile.phone }}
          </p>

          <v-container fill-height mx-0 my-1 pa-0>
            <v-layout row wrap>
              <div
                class="consultant-category"
                v-for="(category, i) in orderedConsultants[currentConsultantNumber]
                  .consultant_profile.categories"
                :key="
                  'consultant_' +
                    orderedConsultants[currentConsultantNumber].id +
                    '_category_' +
                    category.id +
                    '_' +
                    i
                "
              >
                <category-icon
                  class="mr-1"
                  force-color="secondary"
                  :category="category"
                ></category-icon>
                <span :key="'span_name' + category.name" class="mr-2">{{ category.name }}</span>
              </div>
            </v-layout>
          </v-container>
        </user-avatar>
        <v-btn color="secondary" dark flat @click="nextConsultant">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-layout>
      <v-layout row mt-3 wrap text-xs-center>
        <v-flex sm12>
          <div
            v-html="orderedConsultants[currentConsultantNumber].consultant_profile.description"
          ></div>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-list dense v-if="!noListOptions" class="px-2" ripple>
      <v-list-tile to="/openbox/upload" v-if="userCanAccessPath('/openbox/upload')">
        <v-list-tile-content>
          <v-list-tile-sub-title class="subheading">
            <v-icon class="mr-3" color="secondary">mdi-calculator</v-icon>
            {{ $t('A contabilizar') }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="threadForm = true">
        <v-dialog v-model="threadForm" persistent max-width="964px">
          <v-list-tile-content slot="activator">
            <v-list-tile-sub-title class="subheading">
              <v-icon class="mr-3" color="secondary">mdi-comment-text-outline</v-icon>
              {{ $t('Crear una conversación') }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <thread-form
            :new-data="newThreadData"
            @created="addThread"
            @closeForm="threadForm = false"
          ></thread-form>
        </v-dialog>
      </v-list-tile>
      <v-list-tile @click="goToMyConsultant">
        <v-list-tile-content>
          <v-list-tile-sub-title class="subheading">
            <v-icon class="mr-3" color="secondary">mdi-comment-text-multiple-outline</v-icon>
            {{ $t('Mis conversaciones') }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="dateForm = true">
        <v-list-tile-content>
          <v-list-tile-sub-title class="subheading">
            <v-icon class="mr-3" color="secondary">mdi-calendar-range</v-icon>
            {{ $t('Pedir cita') }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-if="$store.getters['customerModules'] && $store.getters['customerModules']['laboral']"
        @click="showLaboralForm = true"
      >
        <v-list-tile-content>
          <v-list-tile-sub-title class="subheading">
            <v-icon class="mr-3" color="secondary">mdi-account-multiple</v-icon>
            {{ $t('Solicitar gestión laboral') }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <v-dialog persistent v-model="dateForm" max-width="500px">
      <consultant-date-form @closeDialog="dateForm = false"></consultant-date-form>

      <!-- <date-menu-form  @created="addDate" @closeForm="dateForm = false" ></date-menu-form> -->
    </v-dialog>
    <v-dialog v-model="showLaboralForm" fullscreen>
      <laboral-request-form
        v-if="showLaboralForm"
        v-model="laboralFormData"
        :codempre="$store.getters['currentCompany']['CLAVEDAT']"
        @submit="submitLaboralForm()"
        @close-form="showLaboralForm = false"
      ></laboral-request-form>
    </v-dialog>
  </v-card>
</template>

<script>
import ThreadForm from './ThreadForm';
import UserAvatar from '@/components/commons/UserAvatar.vue';
import ConsultantDateForm from '@/modules/calendar/components/ConsultantDateForm.vue';
import LaboralRequestForm from '@/modules/laboral/components/forms/laboral-requests/LaboralRequestForm.vue';
import CategoryIcon from '@/components/commons/CategoryIcon.vue';
import AruRouteGuardMixin from '@/mixins/route-guards/AruRouteGuardMixin.js';
import apiCtrl from '@/services/aru-services/aru-api.service.js';

export default {
  mixins: [AruRouteGuardMixin],
  components: {
    ThreadForm,
    UserAvatar,
    ConsultantDateForm,
    CategoryIcon,
    LaboralRequestForm,
  },
  props: {
    noListOptions: Boolean,
  },
  data() {
    return {
      threadForm: false,
      dateForm: false,
      newThreadData: {},
      orderedConsultants: [],
      currentConsultantNumber: 0,
      consultantReady: false,
      savingLaboralForm: false,
      showLaboralForm: false,
      laboralFormData: {},
    };
  },
  mounted() {
    this.consultantReady = false;
    this.orderedConsultants = this.getOrderedConsultants();
    this.consultantReady = true;
  },
  computed: {
    avatarSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xl':
          return 75;
        default:
          return 30;
      }
    },
  },
  methods: {
    submitLaboralForm() {
      this.savingLaboralForm = true;
      apiCtrl
        .post('/laboral-requests', this.laboralFormData)
        .then(() => {
          this.showLaboralForm = false;
        })
        .catch(() => {
          this.savingLaboralForm = false;
        });
    },
    getOrderedConsultants() {
      let result = {
        Fiscal: [],
        Laboral: [],
        Contable: [],
        Otros: [],
      };
      this.$store.state.user.consultants.forEach(consultant => {
        let categories = this.getConsultantCategoryNames(consultant);
        if (categories.includes('Fiscal')) {
          result.Fiscal.push(consultant);
        } else if (categories.includes('Laboral')) {
          result.Laboral.push(consultant);
        } else if (categories.includes('Contable')) {
          result.Contable.push(consultant);
        } else {
          result.Otros.push(consultant);
        }
      });

      return result.Fiscal.concat(result.Laboral, result.Contable, result.Otros);
    },

    getConsultantCategoryNames(consultant) {
      let result = [];
      if (
        !!consultant &&
        consultant.hasOwnProperty('consultant_profile') &&
        consultant.consultant_profile.hasOwnProperty('categories')
      ) {
        consultant.consultant_profile.categories.forEach(category => {
          result.push(category.name);
        });
      }
      return result;
    },

    goToMyConsultant: function() {
      this.$router.push({ name: 'Mi Asesor' });
    },

    nextConsultant() {
      this.consultantReady = false;
      if (this.currentConsultantNumber < this.orderedConsultants.length - 1) {
        this.currentConsultantNumber = this.currentConsultantNumber + 1;
      } else {
        this.currentConsultantNumber = 0;
      }
      this.consultantReady = true;
    },

    addDate: function(date) {},
    addThread(data) {
      this.$router.push('/myconsultant/thread/' + data.data.id);
    },
  },
};
</script>
<style lang="scss"></style>
